import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnraidComponent } from './simple-icons-unraid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnraidComponent ],
    exports:      [ SimpleIconsUnraidComponent ],
    bootstrap:    []
})
export class SimpleIconsUnraidModule {}
